import type { ReactNode } from 'react';
import { useState } from 'react';

import { Trans } from '@lingui/react/macro';
import { ToggleGroup, ToggleGroupItem } from '@repo/videa-components/src/index';

// Style constants
const CARD_STYLES =
  'vai-bg-white vai-rounded-lg vai-border vai-border-gray-200 vai-overflow-hidden';
const CONTENT_STYLES = 'vai-p-6';

interface Tab {
  id: string;
  label: string;
  isSelected?: boolean;
}

interface SectionCardWithHeaderProps {
  title: string;
  children: ReactNode;
  tabs?: Tab[];
  className?: string;
  onTabChange?: (tabId: string) => void;
}

export const SectionCardWithHeader = ({
  title,
  children,
  tabs = [],
  onTabChange,
  className = '',
}: SectionCardWithHeaderProps) => {
  const [selectedTab, setSelectedTab] = useState(
    tabs.find((tab) => tab.isSelected)?.id || tabs[0]?.id || '',
  );

  const handleTabClick = (tabId: string) => {
    setSelectedTab(tabId);
    onTabChange?.(tabId);
  };

  return (
    <div className={`${CARD_STYLES} ${className}`}>
      {/* Header with Title and Tabs */}
      <div className="vai-p-4">
        <div className="vai-flex vai-items-center vai-justify-between">
          <h1 className="vai-text-2xl vai-font-bold vai-text-gray-900">
            <Trans>{title}</Trans>
          </h1>

          {/* Tabs */}
          {/* Disable for now */}
          {/* {tabs.length > 0 && (
            <ToggleGroup
              type="single"
              value={selectedTab}
              onValueChange={(value) => {
                if (value) {
                  handleTabClick(value);
                }
              }}
              className="vai-bg-gray-100 vai-rounded-lg vai-p-1"
            >
              {tabs.map((tab) => (
                <ToggleGroupItem
                  key={tab.id}
                  value={tab.id}
                  className="vai-px-4 vai-py-2 vai-text-sm vai-font-medium vai-rounded-md vai-transition-colors vai-duration-200 data-[state=on]:vai-bg-blue-600 data-[state=on]:vai-text-white data-[state=off]:vai-text-gray-600 data-[state=off]:hover:vai-text-gray-900"
                >
                  <Trans>{tab.label}</Trans>
                </ToggleGroupItem>
              ))}
            </ToggleGroup>
          )} */}
        </div>
      </div>

      {/* Bottom Border - Full Width */}
      <div className="vai-h-px vai-bg-gray-200"></div>

      {/* Content Area */}
      <div className={CONTENT_STYLES}>{children}</div>
    </div>
  );
};
